import { patientOptionsService } from '@/services/patient-options-service'
import { GET_DEMOGRAPHICS, SET_DEMOGRAPHICS } from '@/store/mutation-types'

import { normalize } from 'normalizr'
import { schemas } from '@/store/schemas'

export const mutations = {
  [SET_DEMOGRAPHICS](state, demographicsData) {
    const demographics = normalize(demographicsData, schemas.demographicsData)
    state.races = demographics.entities.races
    state.ethnicities = demographics.entities.ethnicities
    state.genders = demographics.entities.genders
  }
}

export const actions = {
  async [GET_DEMOGRAPHICS]({ commit }) {
    const response = await patientOptionsService.getDemographicsData()
    commit(SET_DEMOGRAPHICS, response.data)
    return response.data
  }
}

export const getters = {}
